module.exports = "https://static.moomoo.com/components/common-redpacket/images/bull.266875541e.png";